module.exports = __webpack_public_path__ + "static/landscape-phone-01b520751ab2da33d171f30c102c43f0.png";